export default {"src":"/_next/static/media/ship-play.343941fd.svg","height":24,"width":120,"blurWidth":0,"blurHeight":0};